function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThreeTwoOne(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "three-two-one",
    width: 120,
    height: 150,
    viewBox: "0 0 31.75 39.688",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(167.91 -76.698)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "background",
    x: -167.91,
    y: 76.698,
    width: 31.75,
    height: 39.688,
    style: {
      display: "none",
      fill: "#808080",
      strokeWidth: 0.17741
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "three",
    style: {
      fill: "#1a237e"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-159.64 114.71q-0.56138 0-0.56138-0.57261v-6.9275q0-0.57261 0.56138-0.57261 0.57261 0 0.57261 0.57261v2.7957q0.2807-0.47157 0.75226-0.70735 0.48279-0.24701 1.0779-0.24701 1.9424 0 1.9424 2.2006v2.8855q0 0.57261-0.56138 0.57261-0.57262 0-0.57262-0.57261v-2.8182q0-0.70735-0.28069-1.033-0.26946-0.3256-0.8533-0.3256-0.68489 0-1.1003 0.43788-0.4042 0.42665-0.4042 1.134v2.6048q0 0.57261-0.57261 0.57261zm-2.4364 0.0225q-1.033 0-1.5382-0.5277-0.50525-0.5277-0.50525-1.527v-2.6497h-0.67366q-0.47157 0-0.47157-0.43788t0.47157-0.43788h0.67366v-1.1564q0-0.57261 0.57261-0.57261 0.56139 0 0.56139 0.57261v1.1564h1.3136q0.47156 0 0.47156 0.43788t-0.47156 0.43788h-1.3136v2.5599q0 0.59507 0.24701 0.89822 0.25823 0.30314 0.83085 0.30314 0.20209 0 0.34805-0.0337 0.14596-0.0449 0.25824-0.0561 0.12351 0 0.2021 0.0898 0.0786 0.0786 0.0786 0.31438 0 0.17964-0.0674 0.3256-0.0561 0.13473-0.21333 0.17965-0.13473 0.0561-0.37051 0.0898-0.22456 0.0337-0.4042 0.0337z",
    style: {
      fill: "#1a237e",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-153.16 114.71q-0.57261 0-0.57261-0.57261v-4.4911q0-0.57261 0.55016-0.57261t0.55016 0.57261v0.48279q0.22455-0.50524 0.67366-0.77471 0.46033-0.26946 1.1115-0.31437 0.41543-0.0337 0.44911 0.4491 0.0449 0.49402-0.48279 0.53893l-0.21333 0.0225q-1.4933 0.14596-1.4933 1.5382v2.5487q0 0.57261-0.57262 0.57261z",
    style: {
      fill: "#1a237e",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-141.03 114.73q-1.3473 0-2.122-0.75226-0.77472-0.76348-0.77472-2.0771 0-0.84208 0.33684-1.4821 0.34805-0.6512 0.95435-1.0105t1.3922-0.35929q1.134 0 1.7852 0.7298 0.65121 0.71858 0.65121 1.9873 0 0.38174-0.44911 0.38174h-3.5704q0.1235 1.7066 1.8077 1.7066 0.33683 0 0.70734-0.0786 0.37052-0.0898 0.71858-0.31438 0.23578-0.13473 0.40419-0.0898 0.17965 0.0337 0.25824 0.19087 0.0786 0.14596 0.0225 0.33683-0.0449 0.17964-0.25824 0.31438-0.38174 0.25823-0.89822 0.39297-0.50524 0.1235-0.96558 0.1235zm-0.16841-4.884q-0.70735 0-1.1228 0.43788-0.41543 0.43788-0.50525 1.1677h3.0652q-0.0337-0.76348-0.4042-1.1789-0.37051-0.42665-1.0329-0.42665zm-5.8621 4.884q-1.3473 0-2.122-0.75226-0.77471-0.76348-0.77471-2.0771 0-0.84208 0.33683-1.4821 0.34806-0.6512 0.95436-1.0105 0.60629-0.35929 1.3922-0.35929 1.134 0 1.7852 0.7298 0.65121 0.71858 0.65121 1.9873 0 0.38174-0.44911 0.38174h-3.5704q0.12351 1.7066 1.8077 1.7066 0.33684 0 0.70735-0.0786 0.37051-0.0898 0.71857-0.31438 0.23578-0.13473 0.4042-0.0898 0.17964 0.0337 0.25824 0.19087 0.0786 0.14596 0.0224 0.33683-0.0449 0.17964-0.25824 0.31438-0.38174 0.25823-0.89821 0.39297-0.50525 0.1235-0.96558 0.1235zm-0.16842-4.884q-0.70734 0-1.1228 0.43788-0.41542 0.43788-0.50525 1.1677h3.0652q-0.0337-0.76348-0.4042-1.1789-0.37051-0.42665-1.033-0.42665z",
    style: {
      fill: "#1a237e",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "two",
    style: {
      fill: "#0d47a1"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-155.9 101.77q-0.57502 0-0.7926-0.59057l-2.3157-6.2942q-0.15541-0.40407 0-0.63719 0.17096-0.24866 0.52841-0.24866 0.23312 0 0.37299 0.10879 0.15541 0.10879 0.24866 0.40407l1.9893 5.6726 2.0514-5.6726q0.18649-0.51286 0.69936-0.51286 0.49732 0 0.68381 0.51286l2.0204 5.6881 2.0204-5.7192q0.10879-0.27974 0.24866-0.37299 0.15542-0.10879 0.38853-0.10879 0.373 0 0.48179 0.27974 0.10878 0.2642-0.0311 0.60611l-2.3156 6.2942q-0.23312 0.59057-0.79261 0.59057-0.57503 0-0.77706-0.59057l-1.9582-5.3773-1.9582 5.3773q-0.21758 0.59057-0.79261 0.59057zm-5.1048 0.0311q-1.3366 0-2.0048-0.69936-0.66827-0.7149-0.66827-2.0514v-3.963h-1.0413q-0.54394 0-0.54394-0.49732 0-0.48178 0.54394-0.48178h1.0413v-1.7872q0-0.63719 0.63719-0.63719 0.62165 0 0.62165 0.63719v1.7872h1.9582q0.54394 0 0.54394 0.48178 0 0.49732-0.54394 0.49732h-1.9582v3.8387q0 0.88585 0.373 1.3521 0.37299 0.4507 1.2122 0.4507 0.29528 0 0.49732-0.0622t0.35745-0.0622q0.13987-0.0155 0.23312 0.0932 0.0932 0.10878 0.0932 0.37299 0 0.18649-0.0777 0.34191-0.0622 0.15541-0.23312 0.21757-0.1865 0.0622-0.49732 0.10879-0.29529 0.0622-0.54395 0.0622z",
    style: {
      fill: "#0d47a1",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-142.41 101.8q-1.1034 0-1.9116-0.48178t-1.2588-1.3521q-0.43516-0.88585-0.43516-2.0825 0-1.1967 0.43516-2.067 0.45069-0.88586 1.2588-1.3676t1.9116-0.48178q1.0879 0 1.896 0.48178 0.82369 0.48178 1.2588 1.3676 0.4507 0.87031 0.4507 2.067 0 1.1967-0.4507 2.0825-0.43515 0.87032-1.2588 1.3521-0.80815 0.48178-1.896 0.48178zm0-1.0102q1.0568 0 1.694-0.74598 0.6372-0.76152 0.6372-2.1602 0-1.4143-0.6372-2.1602-0.63719-0.74598-1.694-0.74598-1.0724 0-1.7095 0.74598-0.62165 0.74598-0.62165 2.1602 0 1.3987 0.62165 2.1602 0.63719 0.74598 1.7095 0.74598z",
    style: {
      fill: "#0d47a1",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "one",
    style: {
      fill: "#01579b"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-142.11 86.85q-1.938 0-3.0671-1.1291-1.1291-1.146-1.1291-3.1008 0-1.2639 0.50557-2.2245 0.50558-0.97744 1.3819-1.4999 0.89318-0.53928 2.056-0.53928 1.6684 0 2.6121 1.0786 0.94373 1.0617 0.94373 2.9323 0 0.52242-0.58983 0.52242h-5.5782q0.0674 1.3987 0.80892 2.1403 0.7415 0.72465 2.056 0.72465 0.55613 0 1.1291-0.13482 0.57298-0.15167 1.1123-0.52242 0.3876-0.25279 0.64039-0.10111 0.26964 0.15167 0.26964 0.47187 0.0169 0.30334-0.33705 0.53928-0.55613 0.40446-1.3313 0.62354-0.75836 0.21908-1.483 0.21908zm-0.21908-7.4825q-1.1628 0-1.8369 0.72465-0.6741 0.72465-0.79207 1.9043h4.9715q-0.0506-1.2471-0.65724-1.938-0.58983-0.69095-1.6852-0.69095zm-12.376 7.4488q-0.67409 0-0.67409-0.7078v-7.0275q0-0.69095 0.65724-0.69095 0.67409 0 0.67409 0.69095v0.82577q0.40446-0.77521 1.146-1.1628 0.7415-0.3876 1.6684-0.3876 2.9155 0 2.9155 3.2357v4.5164q0 0.7078-0.6741 0.7078-0.69094 0-0.69094-0.7078v-4.4322q0-1.146-0.45502-1.6684-0.43816-0.53928-1.4156-0.53928-1.1291 0-1.8032 0.7078-0.65724 0.69095-0.65724 1.8538v4.0783q0 0.7078-0.69095 0.7078zm-6.6506 0.0337q-1.1965 0-2.0728-0.52242-0.87632-0.52242-1.365-1.4662-0.47187-0.96059-0.47187-2.2582t0.47187-2.2414q0.48872-0.96059 1.365-1.483 0.87633-0.52242 2.0728-0.52242 1.1797 0 2.056 0.52242 0.89318 0.52242 1.365 1.483 0.48872 0.94373 0.48872 2.2414t-0.48872 2.2582q-0.47187 0.94374-1.365 1.4662-0.87632 0.52242-2.056 0.52242zm0-1.0954q1.146 0 1.8369-0.80892 0.69095-0.82577 0.69095-2.3425 0-1.5336-0.69095-2.3425t-1.8369-0.80892q-1.1628 0-1.8538 0.80892-0.6741 0.80892-0.6741 2.3425 0 1.5167 0.6741 2.3425 0.69094 0.80892 1.8538 0.80892z",
    style: {
      fill: "#01579b",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "balls-three",
    style: {
      fill: "#3949ab"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-156.15 111.42a3.3073 3.3073 0 0 1-3.3073 3.3073 3.3073 3.3073 0 0 1-3.3073-3.3073 3.3073 3.3073 0 0 1 3.3073-3.3073 3.3073 3.3073 0 0 1 3.3073 3.3073",
    style: {
      fill: "#3949ab",
      strokeWidth: 0.23386
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-148.73 111.42a3.3073 3.3073 0 0 1-3.3073 3.3073 3.3073 3.3073 0 0 1-3.3073-3.3073 3.3073 3.3073 0 0 1 3.3073-3.3073 3.3073 3.3073 0 0 1 3.3073 3.3073",
    style: {
      fill: "#3949ab",
      strokeWidth: 0.23386
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-141.31 111.42a3.3073 3.3073 0 0 1-3.3073 3.3073 3.3073 3.3073 0 0 1-3.3073-3.3073 3.3073 3.3073 0 0 1 3.3073-3.3073 3.3073 3.3073 0 0 1 3.3073 3.3073",
    style: {
      fill: "#3949ab",
      strokeWidth: 0.23386
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "balls-two",
    style: {
      fill: "#1e88e5"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-152.61 97.831a3.9688 3.9688 0 0 1-3.9688 3.9687 3.9688 3.9688 0 0 1-3.9688-3.9687 3.9688 3.9688 0 0 1 3.9688-3.9688 3.9688 3.9688 0 0 1 3.9688 3.9688",
    style: {
      fill: "#1e88e5",
      strokeWidth: 0.28063
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-143.52 97.831a3.9688 3.9688 0 0 1-3.9688 3.9688 3.9688 3.9688 0 0 1-3.9688-3.9688 3.9688 3.9688 0 0 1 3.9688-3.9688 3.9688 3.9688 0 0 1 3.9688 3.9688",
    style: {
      fill: "#1e88e5",
      strokeWidth: 0.28063
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "ball-one",
    d: "m-147.41 82.219a4.6302 4.6302 0 0 1-4.6302 4.6302 4.6302 4.6302 0 0 1-4.6302-4.6302 4.6302 4.6302 0 0 1 4.6302-4.6302 4.6302 4.6302 0 0 1 4.6302 4.6302z",
    style: {
      fill: "#039be5",
      strokeWidth: 0.3274
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeTwoOne);
export default __webpack_public_path__ + "static/media/three-two-one.96c835c1.svg";
export { ForwardRef as ReactComponent };